import axios from 'axios';

// export const API_URL = 'http://localhost:8080';
// export const API_URL = 'https://tl.hkcl.net';
export const API_URL = 'https://tasklync.hkcl.in';

const PUBLIC_AUTH_PATHS = ['/login', '/login-2', '/login-3', '/forgot-password', '/reset-password'];

const isPublicAuthRoute = () =>
    PUBLIC_AUTH_PATHS.some((path) => window.location.pathname.startsWith(path));

const apiService = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'X-Client-Type': 'WEB',
    }
});

let isRefreshing = false;
let failedQueue: Array<{ resolve: (v?: unknown) => void; reject: (e?: unknown) => void }> = [];

const processQueue = (error: unknown) => {
    failedQueue.forEach(prom => {
        if (error) prom.reject(error);
        else prom.resolve();
    });
    failedQueue = [];
};

const shouldAttemptRefresh = (url?: string) =>
    url
    && !url.includes('/api/auth/authorizeUser')
    && !url.includes('/api/auth/authenticateUser')
    && !url.includes('/api/auth/logout')
    && !url.includes('/api/auth/refresh');

/** Unwrap unified ApiResponse envelopes so callers keep using response.data as the payload. */
const unwrapApiResponse = (response: any) => {
    const body = response?.data;
    if (body && typeof body === 'object' && typeof body.success === 'boolean' && 'data' in body) {
        response.data = body.data;
        response.apiMessage = body.message;
        response.apiSuccess = body.success;
        response.apiStatus = body.status;
    }
    return response;
};

apiService.interceptors.response.use(
    (response) => unwrapApiResponse(response),
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 && !originalRequest._retry
            && shouldAttemptRefresh(originalRequest.url)) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                }).then(() => apiService(originalRequest));
            }
            originalRequest._retry = true;
            isRefreshing = true;
            try {
                await axios.post(`${API_URL}/api/auth/refresh`, {}, { withCredentials: true, headers: { 'X-Client-Type': 'WEB' } });
                processQueue(null);
                return apiService(originalRequest);
            } catch (refreshError) {
                processQueue(refreshError);
                sessionStorage.removeItem('userProfile');
                sessionStorage.removeItem('userDetails');
                sessionStorage.removeItem('$3ingT0k3n');
                if (!isPublicAuthRoute()) {
                    window.location.href = '/login';
                }
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }
        // Normalize ApiResponse / string error bodies for callers and avoid opaque AxiosError overlays
        const body = error.response?.data;
        if (body && typeof body === 'object' && body.message) {
            error.message = body.message;
        }
        return Promise.reject(error);
    }
);

export default apiService;
